//---------------| { TOOLS IMPORT } |---------------:
import AnalysisLayout from './PageSpeed';
import AnalysisHistory from './PageSpeed/pages/History';
import AnalysisOverview from './PageSpeed/pages/Overview';
import AnalysisInternalSeo from './PageSpeed/pages/InternalSeo';
import AnalysisSpeed, { PublicSpeed as PublicAnalysisSpeed } from './PageSpeed/pages/Speed';
import AnalysisComparison from './PageSpeed/pages/Comparison';
import AnalysisCrux from './PageSpeed/pages/Crux';
import PageSpeedReport from './PageSpeed/pages/PageSpeedReport';
// -----------------------------------
import ReportLayout from './Report';
import ReportOverview from './Report/pages/Overview';
import ReportDetails from './Report/pages/Details';
// -----------------------------------
import KeywordResearchLayout from './KeywordResearch';
import KeywordResearchClustering from './KeywordResearch/pages/Clustering';
import KeywordResearchClusteringDetails from './KeywordResearch/pages/ClusteringDetails';
import KeywordResearchCombination from './KeywordResearch/pages/Combination';
import KeywordResearchCompetitors from './KeywordResearch/pages/Competitors';
import KeywordResearchKeywordGap from './KeywordResearch/pages/KeywordGap';
import KeywordResearchKeywordsGsc from './KeywordResearch/pages/KeywordsGsc';
import KeywordResearchKeywordsGscDetails from './KeywordResearch/pages/KeywordsGscDetails';
import KeywordResearchMassive from './KeywordResearch/pages/Massive';
import KeywordResearchMassiveDetails from './KeywordResearch/pages/MassiveDetails';
import KeywordResearchPlanner from './KeywordResearch/pages/Planner';
import KeywordResearchPlannerDetails from './KeywordResearch/pages/PlannerDetails';
import KeywordResearchRelatedKeywords from './KeywordResearch/pages/RelatedKeywords';
import KeywordResearchSearchVolume from './KeywordResearch/pages/SearchVolume';
import KeywordResearchAiKeywords from './KeywordResearch/pages/AiKeywords';
import KeywordResearchAiKeywordsDetails from './KeywordResearch/pages/AiKeywordsDetails';

// -----------------------------------
import SettingsLayout from './Settings';
import SettingsAppearance from './Settings/pages/Appearance';
import DomainAccess from './Settings/pages/DomainAccess';
// -----------------------------------
import CrawlLayout from './Crawl';
import CrawlHistory from './Crawl/pages/History';
import CrawlOverview from './Crawl/pages/Overview';
import CrawlPages from './Crawl/pages/Pages';
import CrawlGraph from './Crawl/pages/Graph';
import CrawlTreeBasic from './Crawl/pages/TreeBasic';
import CrawlTreeRadial from './Crawl/pages/TreeRadial';
import CrawlLinkgraph from './Crawl/pages/Linkgraph';
import CrawlInternalLink from './Crawl/pages/InternalLink';
import CrawlExternalLink from './Crawl/pages/ExternalLink';
import CrawlCheckList from './Crawl/pages/CheckList';
// -----------------------------------
import KeywordTrackerLayout from './KeywordTracker';
import KeywordTrackerOverview from './KeywordTracker/pages/Overview';
import KeywordTrackerRankHistorical from './KeywordTracker/pages/RankHistorical';
import KeywordTrackerManage from './KeywordTracker/pages/KeywordsPage';
import KeywordTrackerCompetitors from './KeywordTracker/pages/Competitors';
import KeywordTrackerGroups from './KeywordTracker/pages/Groups';
import KeywordTrackerTags from './KeywordTracker/pages/Tags';
import KeywordTrackerLandingUrls from './KeywordTracker/pages/LandingUrls';
import KeywordTrackerMap from './KeywordTracker/pages/Map';
// -----------------------------------
import SerpLayout from './Serp';
import SerpHistory from './Serp/pages/History';
import SerpOverview from './Serp/pages/Overview';
import SerpResults from './Serp/pages/Results';
import SerpContentBrief from './Serp/pages/ContentBrief';
// -----------------------------------
import PurchaseLayout from './Purchase';
import PurchaseOverview from './Purchase/pages/Overview';
import PurchaseUpgrade from './Purchase/pages/Upgrade';
import PurchasePayment from './Purchase/pages/Payment';
import PurchaseOrder from './Purchase/pages/Order';
import Invoice from './Purchase/pages/Invoice';
import OrdersPage from './Purchase/pages/Orders';
// -----------------------------------
import MembershipLayout from './Membership';
import MembershipAddDomains from './Membership/pages/AddDomains';
import MembershipAddKeywords from './Membership/pages/AddKeywords';
// -----------------------------------
import ProtectedRoute from './Auth/ProtectedRoute';
import Login from './Auth/Login';
import CasdoorCallback from './Auth/CasdoorCallback';
// -----------------------------------
import BacklinkLayout from './BacklinkNew';
import BacklinkOverview from './BacklinkNew/pages/Overview';
import BacklinkBacklinks from './BacklinkNew/pages/Backlinks';
import BacklinkReferralDomain from './BacklinkNew/pages/ReferralDomain';
import BacklinkSpamDomain from './BacklinkNew/pages/SpamDomain';
import BacklinkAnchorTextPage from './BacklinkNew/pages/AnchorTextPage';
import BacklinkReferringIpPage from './BacklinkNew/pages/ReferringIpPage';
import BacklinkInternalPage from './BacklinkNew/pages/InternalPage';
import BacklinkGap from './BacklinkNew/pages/Gap';
import BacklinkNoDataBacklink from './BacklinkNew/pages/NoDataBacklink';
import AiSettings from './Settings/pages/AiSettings';
import ApiKeySettings from './Settings/pages/ApiKeySettings';
import McpSettings from './Settings/pages/McpSettings';

// -----------------------------------
import ContentToolsLayout from './ContentTools';
import ContentToolsAi from './ContentTools/pages/AiContentAnalysis';
import ContentToolsAiDetails from './ContentTools/pages/AiAnalysisDetails';
// -----------------------------------
import TrackerAiLayout from './TrackerAi';
import TrackerAiDashboard from './TrackerAi/pages/DashboardPage';
import TrackerAiPrompts from './TrackerAi/pages/PromptsPage';
import TrackerAiTopics from './TrackerAi/pages/TopicsPage';
import TrackerAiExecutions from './TrackerAi/pages/ExecutionsPage';
import TrackerAiVisibility from './TrackerAi/pages/VisibilityPage';
import TrackerAiCompetitors from './TrackerAi/pages/CompetitorsPage';
import TrackerAiSources from './TrackerAi/pages/SourcesPage';
import TrackerAiSettings from './TrackerAi/pages/SettingsPage';
import TrackerAiOnboarding from './TrackerAi/pages/OnboardingPage';
// -----------------------------------
import SupportLayout from './Support';
import SupportMentoring from './Support/pages/Mentoring';
import WalletTransactions from './Wallet/pages/Transactions';
import WalletPayment from './Wallet/pages/Payment';
import McpChatPage from './Mcp/pages/ChatPage';
import McpConnectPage from './Mcp/pages/ConnectPage';
import McpConnectCallbackPage from './Mcp/pages/ConnectCallbackPage';
import McpHistoryPage from './Mcp/pages/HistoryPage';
import McpPromptsPage from './Mcp/pages/PromptsPage';
import McpSettingsPage from './Mcp/pages/SettingsPage';
import McpSkillsPage from './Mcp/pages/SkillsPage';
import McpFaqStepsPage from './Mcp/pages/FaqStepsPage';
import McpLayout from './Mcp/McpLayout';
// -----------------------------------
import IndexerLayout from './Indexer';
import { OverviewPage as IndexerOverview } from './Indexer/pages/OverviewPage';
import { IndexPage as IndexerIndex } from './Indexer/pages/IndexPage';
import { InspectPage as IndexerInspect } from './Indexer/pages/InspectPage';
import { UrlListPage as IndexerUrls } from './Indexer/pages/UrlListPage';
import { UrlChangesPage as IndexerChanges } from './Indexer/pages/UrlChangesPage';
import { SettingsPage as IndexerSettings } from './Indexer/pages/SettingsPage';
import { OnboardingPage as IndexerOnboarding } from './Indexer/pages/OnboardingPage';

//---------------| { TOOLS EXPORT } |---------------:

export { default as Dashboard } from './Dashboard';

export const Report = {
  Layout: ReportLayout,
  Overview: ReportOverview,
  Details: ReportDetails
};

export const Analysis = {
  Layout: AnalysisLayout,
  History: AnalysisHistory,
  Overview: AnalysisOverview,
  Speed: AnalysisSpeed,
  PublicSpeed: PublicAnalysisSpeed,
  Comparison: AnalysisComparison,
  InternalSeo: AnalysisInternalSeo,
  Crux: AnalysisCrux,
  PageSpeedReport
};

export const Support = {
  Layout: SupportLayout,
  Mentoring: SupportMentoring
};

export const Settings = {
  Layout: SettingsLayout,
  Appearance: SettingsAppearance,
  DomainAccess,
  AI: AiSettings,
  ApiKey: ApiKeySettings,
  MCP: McpSettings
};

export const ContentTools: {
  Layout: typeof ContentToolsLayout;
  Ai: typeof ContentToolsAi;
  AiDetails: typeof ContentToolsAiDetails;
} = {
  Layout: ContentToolsLayout,
  Ai: ContentToolsAi,
  AiDetails: ContentToolsAiDetails
};

export const TrackerAi = {
  Layout: TrackerAiLayout,
  Dashboard: TrackerAiDashboard,
  Prompts: TrackerAiPrompts,
  Topics: TrackerAiTopics,
  Executions: TrackerAiExecutions,
  Visibility: TrackerAiVisibility,
  Competitors: TrackerAiCompetitors,
  Sources: TrackerAiSources,
  Settings: TrackerAiSettings,
  Onboarding: TrackerAiOnboarding
};

export const KeywordResearch = {
  Layout: KeywordResearchLayout,
  Clustering: KeywordResearchClustering,
  ClusteringDetails: KeywordResearchClusteringDetails,
  Combination: KeywordResearchCombination,
  Competitors: KeywordResearchCompetitors,
  Gap: KeywordResearchKeywordGap,
  Gsc: KeywordResearchKeywordsGsc,
  GscDetails: KeywordResearchKeywordsGscDetails,
  Massive: KeywordResearchMassive,
  MassiveDetails: KeywordResearchMassiveDetails,
  Planner: KeywordResearchPlanner,
  PlannerDetails: KeywordResearchPlannerDetails,
  Related: KeywordResearchRelatedKeywords,
  SearchVolume: KeywordResearchSearchVolume,
  AiKeywords: KeywordResearchAiKeywords,
  AiKeywordsDetails: KeywordResearchAiKeywordsDetails
};

export const Crawl = {
  Layout: CrawlLayout,
  History: CrawlHistory,
  Overview: CrawlOverview,
  Pages: CrawlPages,
  Graph: CrawlGraph,
  TreeBasic: CrawlTreeBasic,
  TreeRadial: CrawlTreeRadial,
  Linkgraph: CrawlLinkgraph,
  InternalLink: CrawlInternalLink,
  ExternalLink: CrawlExternalLink,
  CheckList: CrawlCheckList
};

export const KeywordTracker = {
  Layout: KeywordTrackerLayout,
  Overview: KeywordTrackerOverview,
  RankHistorical: KeywordTrackerRankHistorical,
  Manage: KeywordTrackerManage,
  Competitors: KeywordTrackerCompetitors,
  Groups: KeywordTrackerGroups,
  Tags: KeywordTrackerTags,
  LandingUrls: KeywordTrackerLandingUrls,
  Map: KeywordTrackerMap
};

export const Serp = {
  Layput: SerpLayout,
  History: SerpHistory,
  Overview: SerpOverview,
  Results: SerpResults,
  ContentBrief: SerpContentBrief
};

export const Purchase = {
  Layout: PurchaseLayout,
  Overview: PurchaseOverview,
  Upgrade: PurchaseUpgrade,
  Payment: PurchasePayment,
  Order: PurchaseOrder,
  Invoice,
  OrdersPage
};

export const Wallet = {
  Transactions: WalletTransactions,
  Payment: WalletPayment
};

export { default as Domain } from './Domain';
export const BacklinkNew = {
  Layout: BacklinkLayout,
  Overview: BacklinkOverview,
  Backlinks: BacklinkBacklinks,
  ReferralPage: BacklinkBacklinks,
  ReferralDomain: BacklinkReferralDomain,
  SpamDomain: BacklinkSpamDomain,
  AnchorTextPage: BacklinkAnchorTextPage,
  ReferringIpPage: BacklinkReferringIpPage,
  InternalPage: BacklinkInternalPage,
  NoDataBacklink: BacklinkNoDataBacklink,
  Gap: BacklinkGap
};

export const Membership = {
  Layout: MembershipLayout,
  AddDomains: MembershipAddDomains,
  AddKeywords: MembershipAddKeywords
};

export const Auth = {
  ProtectedRoute,
  CasdoorCallback,
  Login
};

export const Mcp = {
  Layout: McpLayout,
  Chat: McpChatPage,
  Connect: McpConnectPage,
  ConnectCallback: McpConnectCallbackPage,
  History: McpHistoryPage,
  Prompts: McpPromptsPage,
  Settings: McpSettingsPage,
  Skills: McpSkillsPage,
  FaqSteps: McpFaqStepsPage
};

export const Indexer = {
  Layout: IndexerLayout,
  Overview: IndexerOverview,
  Index: IndexerIndex,
  Inspect: IndexerInspect,
  Urls: IndexerUrls,
  Changes: IndexerChanges,
  Settings: IndexerSettings,
  Onboarding: IndexerOnboarding
};
